<template>
  <div class="head-page" style="position: relative;min-height: calc(100vh - 82px);">
    <div style="padding: 0 !important;height: calc(100vh - 300px);">
      <OperationHeader
        @child-event="toType"
        @changeTable="changeTable"
        :name="name"
        :showType="showtype"
      />
      <div v-show="showtype == 0">
        <TradingItem
          :symbol="currentSymbol"
          :interval="currentInterval"
          @symbol-changed="handleSymbolChange"
        />
        <OperationBtns :symbol="symbolinfo" />
      </div>
      <div v-show="showtype == 1" class="tmp-box">
        <UsrOperationOrder ref="UsrOperationOrder" />
      </div>
      <Footer />
      <van-popup v-model="show" position="left">
        <OptionTypeList :datalst="dataLst" @change-item-event="changeItem" />
      </van-popup>
    </div>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import {
  TradingItem,
  OperationHeader,
  OperationBtns,
  OptionTypeList,
  UsrOperationOrder,
} from "./components/index";
export default {
  name: "UsrOperation",
  components: {
    TradingItem,
    OperationHeader,
    Footer,
    OperationBtns,
    OptionTypeList,
    UsrOperationOrder,
  },
  data() {
    return {
      currentInterval: "D",
      showtype: 0,
      show: false,
      currentSymbol: "",
      name: "",
      symbolinfo: {},
      timer: null,
      dataLst: [],
    };
  },
  mounted() {
    this.initPage();
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    async getData() {
      await this.$http({
        method: "post",
        url: "getMarketList",
      }).then((res) => {
        if (res && res.data && res.data.list) {
          this.dataLst = res.data.list;
          if (this.dataLst && this.dataLst.length > 0) {
            if (!this.symbolinfo.symbol) {
              this.symbolinfo = this.dataLst[0];
            } else {
              this.dataLst.forEach((item) => {
                if (this.symbolinfo.symbol == item.symbol) {
                  this.symbolinfo = item;
                }
              });
            }
            this.currentSymbol = this.symbolinfo.symbol;
            this.name = this.symbolinfo.title;
          }
        }
      });
    },
    initPage() {
      this.currentSymbol = this.$route.query.currentSymbol;
      this.name = this.$route.query.name;
      if (
        this.currentSymbol &&
        this.currentSymbol.length > 0 &&
        this.name &&
        this.name.length > 0
      ) {
        this.symbolinfo.symbol = this.currentSymbol;
      }
      this.getData();
      const that = this;
      this.$nextTick(() => {
        that.timer = setInterval(() => {
          that.getData();
        }, 2500);
      });
    },
    handleSymbolChange(newSymbol) {
      this.currentSymbol = newSymbol;
    },
    toType() {
      this.show = true;
    },
    changeItem(val) {
      this.show = false;
      this.symbolinfo = val;
      this.currentSymbol = this.symbolinfo.symbol;
      this.name = this.symbolinfo.title;
    },
    changeTable() {
      this.showtype = this.showtype == 0 ? 1 : 0;
      if (this.showtype == 1) {
        const that = this;
        this.$nextTick(() => {
          that.$refs.UsrOperationOrder.active = 1;
          this.$refs.UsrOperationOrder.loadData();
        });
      }
    },
  },
};
</script>

<style>
</style>
